var map = {
	"./sharenting1.jpg": 50885,
	"./sharenting2.jpg": 78209,
	"./sharenting3.jpg": 73988,
	"./sharenting4.jpg": 60645,
	"./sharenting5.jpg": 83491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36115;